import { NoContent1bdx48poqrifq as NoContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EmptyContentClass;
function EmptyContent() {
  if (EmptyContentClass === VOID) {
    class $ extends NoContent() {
      constructor() {
        EmptyContent_instance = null;
        super();
        EmptyContent_instance = this;
        this.v5y_1 = 0n;
      }
      h47() {
        return this.v5y_1;
      }
      toString() {
        return 'EmptyContent';
      }
      hashCode() {
        return 1450860306;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmptyContent()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'EmptyContent');
    EmptyContentClass = $;
  }
  return EmptyContentClass;
}
var EmptyContent_instance;
function EmptyContent_getInstance() {
  if (EmptyContent_instance === VOID)
    new (EmptyContent())();
  return EmptyContent_instance;
}
//region block: exports
export {
  EmptyContent_getInstance as EmptyContent_getInstance55lf7d2oew98,
};
//endregion

//# sourceMappingURL=Content.mjs.map
